import { render, staticRenderFns } from "./photoAlbum.vue?vue&type=template&id=409a490a&scoped=true"
import script from "./photoAlbum.vue?vue&type=script&lang=ts"
export * from "./photoAlbum.vue?vue&type=script&lang=ts"
import style0 from "./photoAlbum.vue?vue&type=style&index=0&id=409a490a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409a490a",
  null
  
)

export default component.exports